(function Segments($, Adzuki)
{
	"use strict";

	var id;
	var row;
	var countCell;
	var resultCell;
	var count;

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Segments/index', function onload()
		{
			$('.auto-assign').on(
				'click',
				function autoAssign(e) {
					id         = $(this).data('segment-id');
					row        = $(this).parents('.table-row');
					countCell  = $(row).find('.current-count');
					resultCell = $(this).parents('p');
					count      = parseInt($(countCell).text());

					e.preventDefault();

					$(countCell).html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-pulse fa-fw"></i>');
					$(resultCell).html('<i class="'+Adzuki.FaIcon.getIconStyle('refresh')+' fa-lg disabled" aria-hidden="true"></i>');

					assignClients(id);
				}
			);

			$('.current-count').each(function getCurrentCount() {
				var id           = $(this).data("segment-id"),
					$segment_obj = $(this);

				Adzuki.Ajax.get(Adzuki.base_uri + '/Segments/currentCount/' + id).then(
					function success(data) {
						$segment_obj.html(data["count"]);
					}
				);
			});
		});
	});

	function assignClients(id)
	{
		Adzuki.Ajax
		.get(
			Adzuki.base_uri + '/Segments/assign/' + id
		).then(
			function success(data) {
				setCount(data.result);

				if (data.errors.length > 0) {
					setError(data.errors);
				}
			}
		);
	}

	function setCount(result)
	{
		if (result) {
			$(countCell).text(result + count);
			$(resultCell).text(result + ' Clients added.');
			$(row).addClass('success');
		} else {
			$(countCell).text(count);
			$(resultCell).text('No clients added.');
		}
	}

	function setError(errors)
	{
		$(countCell).text(errors[0]);
	}

}(jQuery, window.Adzuki || {}));
